import React from "react";

/**
 * Minimalist drone icon — top-down view with 4 rotors and a central body.
 * Inherits color via currentColor for easy theming.
 */
export const DroneLogo = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* Diagonal arms */}
    <line x1="8" y1="8" x2="24" y2="24" />
    <line x1="24" y1="8" x2="8" y2="24" />

    {/* 4 rotors */}
    <circle cx="8" cy="8" r="3.2" fill="currentColor" fillOpacity="0.18" />
    <circle cx="24" cy="8" r="3.2" fill="currentColor" fillOpacity="0.18" />
    <circle cx="8" cy="24" r="3.2" fill="currentColor" fillOpacity="0.18" />
    <circle cx="24" cy="24" r="3.2" fill="currentColor" fillOpacity="0.18" />

    {/* Propeller blades (tiny dashes) */}
    <line x1="8" y1="5.5" x2="8" y2="10.5" opacity="0.7" />
    <line x1="5.5" y1="8" x2="10.5" y2="8" opacity="0.7" />
    <line x1="24" y1="5.5" x2="24" y2="10.5" opacity="0.7" />
    <line x1="21.5" y1="8" x2="26.5" y2="8" opacity="0.7" />
    <line x1="8" y1="21.5" x2="8" y2="26.5" opacity="0.7" />
    <line x1="5.5" y1="24" x2="10.5" y2="24" opacity="0.7" />
    <line x1="24" y1="21.5" x2="24" y2="26.5" opacity="0.7" />
    <line x1="21.5" y1="24" x2="26.5" y2="24" opacity="0.7" />

    {/* Central body */}
    <circle cx="16" cy="16" r="3.4" fill="#ffffff" stroke="none" />
    <circle cx="16" cy="16" r="1.4" fill="currentColor" />
  </svg>
);

export default DroneLogo;
